import ajax from '@/api/register';

// export default function wxShare ({ desc, link } = {}) {
export default function wxShare (link, activityTitle, desc) { // 分享地址, 标题, 内容
  setTimeout(() => { // router的hashChange 可能在 beforeEach之后
    ajax.wxShare({url: window.location.href}).then(response => {
      if (response.data && response.code === '0') {
        const linkUrl = window.location.href;
        const title = '每时每刻-想动就动！快来和我一起运动啦！' // 分享图标
        const content = '快来加入我的运动挑战吧,运动现金等你瓜分！';
        const imgUrl = 'https://h5.xiangdongcn.com/images/mmexport1617275699961.png';
        wx.config(JSON.parse(response.data))
        wx.ready(() => {
          wx.onMenuShareAppMessage({ // 分享给朋友 ,在config里面填写需要使用的JS接口列表，然后这个方法才可以用
          title: activityTitle || title, // 分享标题
          desc: desc || content, // 分享描述
          link: link || linkUrl, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: function() {
            // 用户确认分享后执行的回调函数
            // alert('成功了')
          },
          cancel: function() {
            // 用户取消分享后执行的回调函数
            // alert('失败')
          }
          });
          wx.onMenuShareTimeline({ // 分享朋友圈
            title: title, // 分享标题
            desc: desc || content, // 分享描述
            link: link || linkUrl, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function() {
              // 用户确认分享后执行的回调函数
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            }
          });
          wx.onMenuShareQQ({ // 分享QQ ,在config里面填写需要使用的JS接口列表，然后这个方法才可以用
            title: title, // 分享标题
            desc: desc || content, // 分享描述
            link: link || linkUrl, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function() {
              // 用户确认分享后执行的回调函数
              // alert('成功了')
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
              // alert('失败')
            }
          });
          wx.onMenuShareWeibo({ // 分享微博 ,在config里面填写需要使用的JS接口列表，然后这个方法才可以用
            title: title, // 分享标题
            desc: desc || content, // 分享描述
            link: link || linkUrl, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function() {
              // 用户确认分享后执行的回调函数
              // alert('成功了')
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
              // alert('失败')
            }
          });
          wx.onMenuShareQZone({ // 分享QQ空间 ,在config里面填写需要使用的JS接口列表，然后这个方法才可以用
            title: title, // 分享标题
            desc: desc || content, // 分享描述
            link: link || linkUrl, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function() {
              // 用户确认分享后执行的回调函数
              // alert('成功了')
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
              // alert('失败')
            }
          });
        })
        wx.error((res) => {
        })
      }
    });
  }, 100)
}




// WEBPACK FOOTER //
// ./src/utils/wxShare.js